import Phaser from "phaser";
import { GAME_WIDTH } from "../constants";
import { createAnimations, loadBootAssets, loadGameAssets } from "../assets/loader";
import { ensurePrimitiveTextures } from "../assets/primitives";
import { addCoverImage } from "../ui/chrome";
import { bodyStyle, titleStyle } from "../ui/theme";
import { audioManager } from "../systems/AudioManager";

export class BootScene extends Phaser.Scene {
  constructor() {
    super("Boot");
  }

  preload(): void {
    loadBootAssets(this);
  }

  create(): void {
    addCoverImage(this, "menu-background", 0);
    const logo = this.add.image(GAME_WIDTH / 2, 168, "logo-hibernation-run");
    logo.setScale(Math.min(760 / logo.width, 280 / logo.height));

    this.add.text(GAME_WIDTH / 2, 330, "Gathering autumn supplies…", titleStyle(28)).setOrigin(0.5);
    const barBg = this.add.rectangle(GAME_WIDTH / 2, 400, 420, 22, 0x2a1a10, 0.85);
    const bar = this.add.rectangle(barBg.x - 206, 400, 4, 14, 0xe8b84a).setOrigin(0, 0.5);
    const percent = this.add.text(GAME_WIDTH / 2, 436, "0%", bodyStyle(20)).setOrigin(0.5);
    percent.setColor("#f3e6c8");

    const ring = this.add.graphics();
    ring.lineStyle(7, 0xe8b84a, 1);
    ring.beginPath();
    ring.arc(0, 0, 26, 0.2, Math.PI * 1.45);
    ring.strokePath();
    ring.lineStyle(5, 0xf3e6c8, 0.85);
    ring.beginPath();
    ring.arc(0, 0, 16, 2.1, Math.PI * 1.7);
    ring.strokePath();
    const spinner = this.add.container(GAME_WIDTH / 2, 510, [ring]);
    this.tweens.add({ targets: spinner, angle: 360, duration: 1100, repeat: -1 });

    this.load.on("progress", (value: number) => {
      bar.width = Math.max(4, 412 * value);
      percent.setText(`${Math.round(value * 100)}%`);
    });
    this.load.once("complete", () => {
      createAnimations(this);
      ensurePrimitiveTextures(this);
      const startMenu = (): void => {
        this.time.delayedCall(250, () => this.scene.start("Menu"));
      };
      if (document.fonts?.load) {
        void document.fonts.load('24px "Alfa Slab One"').then(startMenu, startMenu);
      } else {
        startMenu();
      }
    });

    this.input.once("pointerdown", () => {
      void audioManager.unlock();
    });
    this.input.keyboard?.once("keydown", () => {
      void audioManager.unlock();
    });

    loadGameAssets(this);
    this.load.start();
  }
}
